/*
 * @Description: 
 * @Author: ywj
 * @Date: 2025-02-08 17:23:26
 * @LastEditTime: 2025-03-07 09:19:44
 * @LastEditors: ywj@originqc.com
 */
// /*
//  * @Description:公共菜单
//  * @Author: ywj
//  * @Date: 2025-02-08 17:23:26
//  * @LastEditTime: 2025-02-08 17:34:40
//  * @LastEditors: ywj@originqc.com
//  */

import React, { useState,useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import rightIcon from './img/right.png'
import More from '../more'
import './index.scss';

interface IMenu {
  categoryData: any,
  setSearchName?: (value: string | null) => void,
  searchName?: string,
  handleMenuLeaveHead?: () => void,
  bgColor?: string
}
const GoodsMenu: React.FC<IMenu> = (props) => {
  const [activeCategory, setActiveCategory] = useState<string | null>('');
  const { categoryData, setSearchName, searchName,bgColor} = props;
  const navigate = useNavigate();
  const menuContainerRef = useRef<HTMLDivElement>(null);

  const handleClickItem = (item: any, parentName: string) => {
    if (item?.productSn) { //商品跳转到详情
      window.open(`/detail?productSn=${item?.productSn}`);
    } else {
      if (searchName) {
        setSearchName && setSearchName(null);
        window.open(`/shop/search?categoryId=${item?.id}&parentName=${parentName}`);
      } else {
        window.open(`/shop/search?categoryId=${item?.id}&parentName=${parentName}`);
      }

    }
    if(props?.handleMenuLeaveHead){//二级头部展示的菜单，点击子菜单隐藏菜单
      props?.handleMenuLeaveHead();
    }
  }

  const subMenuDom = (childVal: any, parentName: string) => {
    if (childVal?.length === 0) {
      return;
    }
    return (
      <div
        className="sub-menu-container"
        onMouseLeave={handleMouseLeave}
        style={{boxShadow: childVal?.length > 0 ? '0 8px 16px rgba(0,0,0,.18)' : 'none'}}
      >
        <div className="sub-menu-content">
          {childVal?.length > 0 && (childVal.length > 14 ? childVal.slice(0, 14) : childVal)?.map((itm: any) => {
            return (
              <div
                className="sub-menu-item"
                key={itm.id}
                onClick={() => handleClickItem(itm, parentName)}
              >
                <img
                  src={itm.pic||itm?.albumPics}
                  alt=""
                  className='pic'
                />
                <p className='menu-item-text1'>{itm.name}</p>
              </div>
            );
          })}
          {childVal?.length > 0 && childVal.length > 14?
            <div className="more-menu">
              <More data={categoryData?.find((cat: any) => cat.name === activeCategory)} />
            </div>
            : null}
        </div>
      </div>
    );
  };

  const handleMouseEnter = (title: string) => {
    setActiveCategory(title);
  };

  const handleMouseLeave = (e: React.MouseEvent<HTMLDivElement>) => {
    if (menuContainerRef.current && !menuContainerRef.current?.contains(e.relatedTarget as Node)) {
      setActiveCategory(null);
      if(props?.handleMenuLeaveHead){//二级头部展示的菜单，leave子菜单隐藏菜单
        props?.handleMenuLeaveHead();
      }
    }
  };

  return (
    <div className="goods-menu-container"
    ref={menuContainerRef}
      onMouseLeave={handleMouseLeave}
    >
      <div className="goods-menu-content" style={{background:bgColor}}>
        <div className="goods-menu-content-scroll">
        {categoryData?.map((item: any) => {
          return (
            <div
              // className="goods-menu-item"
              className={`goods-menu-item ${activeCategory === item.name ? 'active' : ''}`}
              key={item.id}
              onMouseEnter={() => handleMouseEnter(item.name)}
            >
              <span
                className='menu-item-text'
              >
                {item.name}
              </span>
              <img
                src={rightIcon}
                alt='right'
                className='right-icon'
              />
            </div>
          );
        })}
      </div>
      </div>
      {activeCategory !== null && (
        <div className="sub-menu">
          {subMenuDom(
            categoryData?.find((cat: any) => cat.name === activeCategory)?.children.length > 0
              ?
              categoryData?.find((cat: any) => cat.name === activeCategory)?.children
              :
              (categoryData?.find((cat: any) => cat.name === activeCategory)?.products),
            activeCategory)
          }
        </div>
      )}
    </div>
  );
};

export default GoodsMenu;